<app-view-item
  *ngIf="disabled"
  [text]="displayText"
  [borderless]="borderless"
></app-view-item>

<nz-select
  *ngIf="!disabled"
  [(ngModel)]="value"
  nzShowSearch
  (ngModelChange)="onModelChange($event)"
  (nzOnSearch)="onSearch($event)" 
  nzAllowClear="true"
  [nzDropdownMatchSelectWidth]="false"
  [required]="isRequired"
  autocomplete="off"
  [nzFilterOption]="nzFilterOption"
>
  <nz-option
    *ngFor="let item of filteredOptions"
    [nzValue]="fieldName === 'name' ? item.name : item.code"
    [nzLabel]="item.name"
    nzCustomContent
  >
    <div class="dropdown-container">
      <strong>{{ item.code }}</strong>
      -
      <span> {{ item.name }}</span>
    </div>
  </nz-option>
</nz-select>
